import useSharedEntities from '../../../modules/shared-entities/hooks/useSharedEntities';
import { IGetSharedEntityResponse } from '../../../modules/shared-entities/types/sharedEntities.types';
import useProductDetailsStore from '../../../stores/ProductDetails/productDetails.store';
import { selectIsProductDetailsOpen } from '../../../stores/ProductDetails/productDetails.store.selectors';
import useSharedEntitystore from '../../../stores/SharedEntities/sharedEntities.store';

interface UsePublicNavigationOutput {
  sharedEntity?: IGetSharedEntityResponse;
  isProductDetailsEnabled: boolean;
  isLoginButtonVisible: boolean;
}

export const usePublicNavigation = (): UsePublicNavigationOutput => {
  const sharedEntity = useSharedEntitystore((state) => state.sharedEntity);
  const { disableProductDetails, isShowroomActiveTab } = useSharedEntities({});
  const isProductDetailsOpen = useProductDetailsStore(selectIsProductDetailsOpen);

  const isProductDetailsEnabled = !disableProductDetails;

  return {
    sharedEntity,
    isProductDetailsEnabled,
    isLoginButtonVisible:
      !isShowroomActiveTab && !(isProductDetailsEnabled && isProductDetailsOpen),
  };
};
